/***************************************************************************/
"use client";
/***************************************************************************/

import React from "react";
import { Alert, AlertContent, AlertIcon, AlertTitle } from "../alert";
import If from "../if";

const FormErrors: React.FC<{
  formErrors?: string[] | undefined;
}> = ({ formErrors }) => {
  return (
    <If condition={(formErrors ?? []).length > 0}>
      <If.True>
        <Alert variant="error" className="mt-3">
          <AlertIcon />
          <AlertContent>
            <AlertTitle>
              {formErrors?.map((it) => (
                <div key={["_", it.replace(" ", "_")].join("")}>{it}</div>
              ))}
            </AlertTitle>
          </AlertContent>
        </Alert>
      </If.True>
    </If>
  );
};

export { FormErrors };
